import React from "react";

interface IProps {
  size?: string;
}

const HeartIcon: React.FC<IProps> = ({ size = '18' }) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 21"
      className={`h-[${size}px] w-[${size}px]`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2530_50017)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4557 3.59046C11.2312 2.71796 13.4739 1.20561 16.2401 2.13628C19.0062 3.06696 19.7624 6.10027 19.7947 7.50059C19.8378 9.50412 18.0303 14.4677 10.4557 18.2938C7.50423 16.9905 1.52378 13.0071 1.21356 7.50059C1.06241 4.81768 2.56749 2.79399 4.86513 2.02816C5.92078 1.67642 8.51679 1.49645 10.4557 3.59046ZM15.2383 3.17037C12.644 2.70503 10.9689 4.50606 10.4557 5.46474C8.69776 2.80197 6.27625 2.82567 5.28523 3.17037C1.89215 4.55992 2.15067 8.08226 3.63716 10.7967C4.82636 12.9683 8.67833 15.8594 10.4557 17.0335C11.7483 16.4188 15.3675 13.188 17.3064 10.7967C19.2454 8.40541 18.4812 3.75204 15.2383 3.17037Z"
          fill="#F4F2F5"
        />
        <path
          d="M10.4557 5.46474C10.9689 4.50606 12.644 2.70503 15.2383 3.17037C18.4812 3.75204 19.2454 8.40541 17.3064 10.7967C15.3675 13.188 11.7483 16.4188 10.4557 17.0335C8.67833 15.8594 4.82636 12.9683 3.63716 10.7967C2.15067 8.08226 1.89215 4.55992 5.28523 3.17037C6.27625 2.82567 8.69776 2.80197 10.4557 5.46474Z"
          fill="#FE4F6E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.4557 3.59046C11.2312 2.71796 13.4739 1.20561 16.2401 2.13628C19.0062 3.06696 19.7624 6.10027 19.7947 7.50059C19.8378 9.50412 18.0303 14.4677 10.4557 18.2938C7.50423 16.9905 1.52378 13.0071 1.21356 7.50059C1.06241 4.81768 2.56749 2.79399 4.86513 2.02816C5.92078 1.67642 8.51679 1.49645 10.4557 3.59046ZM15.2383 3.17037C12.644 2.70503 10.9689 4.50606 10.4557 5.46474C8.69776 2.80197 6.27625 2.82567 5.28523 3.17037C1.89215 4.55992 2.15067 8.08226 3.63716 10.7967C4.82636 12.9683 8.67833 15.8594 10.4557 17.0335C11.7483 16.4188 15.3675 13.188 17.3064 10.7967C19.2454 8.40541 18.4812 3.75204 15.2383 3.17037Z"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M10.4557 5.46474C10.9689 4.50606 12.644 2.70503 15.2383 3.17037C18.4812 3.75204 19.2454 8.40541 17.3064 10.7967C15.3675 13.188 11.7483 16.4188 10.4557 17.0335C8.67833 15.8594 4.82636 12.9683 3.63716 10.7967C2.15067 8.08226 1.89215 4.55992 5.28523 3.17037C6.27625 2.82567 8.69776 2.80197 10.4557 5.46474Z"
          stroke="white"
          strokeWidth="0.3"
        />
        <g filter="url(#filter0_di_2530_50017)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5076 2.88623C12.7852 2.39947 11.0274 4.28338 10.4889 5.28618C8.64414 2.50088 6.10306 2.52567 5.0631 2.88623C1.50247 4.33972 1.77376 8.02416 3.33365 10.8635C4.58157 13.135 8.62376 16.1592 10.4889 17.3874C11.8453 16.7444 15.6433 13.3649 17.6779 10.8635C19.7126 8.36218 18.9107 3.49467 15.5076 2.88623ZM3.41667 5.84741C3.53794 4.93469 4.61158 4.01603 5.30603 3.87714C6.55603 3.46048 7.87083 4.45285 7.45417 5.28618C7.0375 6.11951 5.57872 6.89673 4.84837 7.00258C4.43601 7.06234 3.24734 7.12171 3.41667 5.84741Z"
            fill="url(#paint0_linear_2530_50017)"
          />
          <path
            d="M5.30603 3.87714C4.61158 4.01603 3.53794 4.93469 3.41667 5.84741C3.24734 7.12171 4.43601 7.06234 4.84837 7.00258C5.57872 6.89673 7.0375 6.11951 7.45417 5.28618C7.87083 4.45285 6.55603 3.46048 5.30603 3.87714Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_di_2530_50017"
          x="1.23828"
          y="2.71631"
          width="18.5449"
          height="18.6709"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2530_50017"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2530_50017"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.95918 0 0 0 0 0.0658031 0 0 0 0 0.0658031 0 0 0 0.01 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_2530_50017"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2530_50017"
          x1="10.5109"
          y1="2.71631"
          x2="10.5109"
          y2="17.3874"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF5874" />
          <stop offset="1" stopColor="#D73E68" />
        </linearGradient>
        <clipPath id="clip0_2530_50017">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5 0.0141602)"
          />
        </clipPath>
      </defs>
    </svg>
  );

export default HeartIcon;
